import { HP, legSwing, pt } from '../enemy-parts';
/* ============================================================
   家族 ORB 球 —— 圓
   ============================================================

   由 `tools/port-families.mjs` 從 `enemy_sample_ani.html` §5 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-families.mjs --check`（逐一比對數字字面值序列）。

   本族成員（威脅色決定身分，剪影決定家族）：
     DORN    vio 棘　自爆・逼位
     ROLLE   red 滾輪　滾進・輾壓
     AUGE    amb 眼　浮空・凝視
     BLASE   azu 泡　護盾・展開
     KLUMPEN red 團塊　深層・滾撞
     IRIS    vio 虹　深層・凝視

   `parts` 的材質名（armor/dark/trim/glow/armorE/glowE）由
   `enemy-parts.ts` 的 `enemyPalette(tint)` 解析 —— 型別表只寫形狀。 */

export var ORB = [
  /* ─ 5 ─────────────────────────────────────────────────────────
     DORN 棘 —— 全表唯一的圓。引信直接畫在赤道環上：脈動變快＝快炸了。
     這是「用動畫講數值」，不是「用 UI 講數值」。 */
  {
    id:'dorn', fam:'orb', code:'DORN', zh:'棘', role:'自爆・逼位', tint:'vio',
    sil:'球體＋雙角', h:0.94, w:0.82, wt:2.0,
    spd:2.4, turn:2.8, gait:2.4, rng:1.9, tTel:1.05, tAtk:0.22, tRec:0.50,
    q0:{lg:1, bd:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'快引信', q:{bd:0.84}, sp:1.35, sc:0.84},
          {n:'母體', q:{bd:1.24}, sp:0.76, sc:1.22}],
    parts:[
      pt('oct','dark', [0.68,0.68,0.68],[0,0.54,0],null, function(P,o){
          var k = 1 + 0.09*Math.sin(o.t*(4 + 22*o.tel)) + 0.55*o.atk;
          P.sx *= k*o.q.bd; P.sy *= k*o.q.bd; P.sz *= k*o.q.bd; }),
      pt('tor','glow', [0.84,0.84,0.85],[0,0.54,0],[HP,0,0], function(P,o){
          var k = (1 + 0.16*Math.sin(o.t*(4 + 22*o.tel)) + 0.9*o.atk) * o.q.bd;
          P.sx *= k; P.sy *= k; P.rz += o.t*(0.8 + 5*o.tel); }),
      pt('cone','armor',[0.19,0.46,0.19],[ 0.23,0.84,0.10],[-0.30,0,0.46]),
      pt('cone','armor',[0.19,0.46,0.19],[-0.23,0.84,0.10],[-0.30,0,-0.46]),
      pt('cyl','trim', [0.12,0.44,0.12],[ 0.19,0.22,-0.04],null, legSwing( 1,0.22,0.46)),
      pt('cyl','trim', [0.12,0.44,0.12],[-0.19,0.22,-0.04],null, legSwing(-1,0.22,0.46))
    ],
    ex:[ pt('cone','armorE',[0.19,0.46,0.19],[ 0.28,0.54,-0.20],[0.5,0,0.9]),
         pt('cone','armorE',[0.19,0.46,0.19],[-0.28,0.54,-0.20],[0.5,0,-0.9]),
         pt('cone','armorE',[0.19,0.46,0.19],[0,0.54,-0.34],[1.9,0,0]),
         pt('tor','glowE',[0.70,0.70,0.7],[0,0.54,0],[0,0,0]),
         pt('oct','armorE',[0.24,0.30,0.24],[0,1.00,0]) ],
    pose:function(o){
      o.ry = 0.05*Math.abs(Math.sin(o.ph*Math.PI * 2))*o.mv;
      o.rp = 0.06*o.mv;
      o.rr = 0.16*Math.sin(o.ph*Math.PI * 2)*o.mv;
      o.rz = 0;
    }
  },
  /* ── 家族 ORB 球 ── 全表唯一的圓。vio 是 DORN。 */
  {
    id:'rolle', fam:'orb', code:'ROLLE', zh:'滾輪', role:'滾進・輾壓', tint:'red',
    sil:'球體＋雙箍', h:0.96, w:0.96, wt:2.2,
    spd:2.8, turn:2.0, gait:2.2, rng:1.8, tTel:0.34, tAtk:0.24, tRec:0.55,
    q0:{bd:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'疾滾', q:{bd:0.84}, sp:1.50, sc:0.86},
          {n:'重輪', q:{bd:1.26}, sp:0.74, sc:1.20}],
    parts:[
      pt('oct','dark', [0.86,0.86,0.86],[0,0.46,0], null, function(P,o){
          var k = o.q.bd; P.sx*=k; P.sy*=k; P.sz*=k; P.rx += o.t*2.4*o.mv; }),
      pt('tor','armor',[1.00,1.00,0.60],[0,0.46,0],[0,HP,0], function(P,o){
          var k = o.q.bd; P.sx*=k; P.sy*=k; P.rz += o.t*2.4*o.mv; }),
      pt('tor','armor',[0.96,0.96,0.50],[0,0.46,0],[HP,0,0], function(P,o){
          var k = o.q.bd; P.sx*=k; P.sy*=k; P.rz += o.t*1.2; }),
      pt('box','glow', [0.16,0.16,1.02],[0,0.46,0],null, function(P,o){
          var k = 1 + 1.8*o.tel + 2.0*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cyl','trim', [0.20,1.06,0.20],[0,0.46,0],[0,0,HP]),
      pt('cone','trim',[0.26,0.30,0.26],[0,0.46,0.50],[-HP,0,0], function(P,o){
          P.z += o.atk*0.26; })
    ],
    ex:[ pt('tor','glowE',[1.14,1.14,0.34],[0,0.46,0],[0,HP,0], function(P,o){ P.rz += o.t*3.0; }),
         pt('oct','armorE',[0.28,0.28,0.28],[0,0.46,-0.50]) ],
    pose:function(o){
      o.ry = 0.05*Math.abs(Math.sin(o.ph*Math.PI * 2))*o.mv;
      o.rp = o.tel*0.14 - o.atk*0.20;
      o.rz = -o.tel*0.20 + o.atk*0.90;
    }
  },
  {
    id:'auge', fam:'orb', code:'AUGE', zh:'眼', role:'浮空・凝視', tint:'amb',
    sil:'浮空球＋單環眼眶', h:1.70, w:0.90, fly:1.24, wt:1.0,
    spd:1.7, turn:2.6, gait:1.0, rng:7.0, tTel:0.85, tAtk:0.28, tRec:1.00,
    q0:{bd:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'游眼', q:{bd:0.84}, sp:1.40, sc:0.88},
          {n:'巨瞳', q:{bd:1.28}, sp:0.74, sc:1.18}],
    parts:[
      pt('oct','dark', [0.78,0.78,0.78],[0,1.24,0], null, function(P,o){
          var k = o.q.bd; P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('tor','armor',[0.98,0.98,0.55],[0,1.24,0.14],null, function(P,o){
          var k = o.q.bd; P.sx*=k; P.sy*=k; P.rz += o.t*0.6; }),
      pt('oct','glow', [0.34,0.34,0.34],[0,1.24,0.36],null, function(P,o){
          var k = o.q.bd*(1 + 0.9*o.tel + 1.8*o.atk*(1-o.atk));
          P.sx*=k; P.sy*=k; P.sz*=k; P.z += o.tel*0.06; }),
      pt('box','armor',[0.16,0.44,0.52],[0,1.58,-0.24],[0.28,0,0]),
      pt('cyl','trim', [0.14,0.52,0.14],[ 0.44,1.10,-0.10],[0,0,-0.5]),
      pt('cyl','trim', [0.14,0.52,0.14],[-0.44,1.10,-0.10],[0,0, 0.5])
    ],
    ex:[ pt('tor','glowE',[1.20,1.20,0.30],[0,1.24,-0.04],[0.3,0,0], function(P,o){ P.rz -= o.t*1.4; }),
         pt('oct','armorE',[0.24,0.24,0.24],[0,1.24,-0.44]) ],
    pose:function(o){
      o.ry = 0.10*Math.sin(o.t*1.5) + 0.05*Math.sin(o.t*2.7);
      o.rp = -0.06 + o.tel*0.12 - o.atk*0.18;
      o.rr = 0.14*Math.sin(o.t*0.9);
      o.rz = -o.atk*0.14;
    }
  },
  {
    id:'blase', fam:'orb', code:'BLASE', zh:'泡', role:'護盾・展開', tint:'azu',
    sil:'球體＋交叉雙環', h:1.16, w:1.10, wt:0.6,
    spd:1.4, turn:1.5, gait:1.6, rng:5.0, tTel:1.00, tAtk:0.55, tRec:1.25,
    q0:{bd:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'快展', q:{bd:0.84}, sp:1.38, sc:0.90},
          {n:'厚壁', q:{bd:1.26}, sp:0.70, sc:1.16}],
    parts:[
      pt('oct','dark', [0.56,0.56,0.56],[0,0.66,0]),
      pt('tor','armor',[1.10,1.10,0.42],[0,0.66,0],[HP,0,0], function(P,o){
          var k = o.q.bd*(1 + 0.8*o.tel + 1.4*o.atk); P.sx*=k; P.sy*=k; P.rz += o.t*1.1; }),
      pt('tor','armor',[1.06,1.06,0.42],[0,0.66,0],[0,HP,0], function(P,o){
          var k = o.q.bd*(1 + 0.8*o.tel + 1.4*o.atk); P.sx*=k; P.sy*=k; P.rz -= o.t*1.4; }),
      pt('oct','glow', [0.34,0.34,0.34],[0,0.66,0],null, function(P,o){
          var k = 1 + 0.25*Math.sin(o.t*3.2) + 1.5*o.tel; P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('cone','trim',[0.14,0.62,0.14],[ 0.34,0.31,-0.16],[Math.PI,0,0], legSwing( 1,0.31,0.22)),
      pt('cone','trim',[0.14,0.62,0.14],[-0.34,0.31,-0.16],[Math.PI,0,0], legSwing(-1,0.31,0.22)),
      pt('cone','trim',[0.14,0.62,0.14],[0,0.31,0.34],[Math.PI,0,0], legSwing(1,0.31,0.22))
    ],
    ex:[ pt('tor','glowE',[1.34,1.34,0.26],[0,0.66,0],[0,0,HP], function(P,o){ P.rz += o.t*0.8; }),
         pt('oct','armorE',[0.22,0.22,0.22],[0,1.18,0]) ],
    pose:function(o){
      o.ry = 0.04*Math.sin(o.ph*2*Math.PI * 2)*o.mv + 0.05*Math.sin(o.t*1.8);
      o.rp = 0.03 + 0.03*o.mv;
    }
  },
  {
    id:'klumpen', fam:'orb', deep:1, code:'KLUMPEN', zh:'團塊', role:'深層・滾撞', tint:'red',
    sil:'不規則球叢', h:1.02, w:1.06, wt:1.8,
    spd:2.5, turn:1.8, gait:2.0, rng:1.8, tTel:0.34, tAtk:0.24, tRec:0.55,
    q0:{bd:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'疾團', q:{bd:0.84}, sp:1.48, sc:0.86},
          {n:'重團', q:{bd:1.26}, sp:0.74, sc:1.20}],
    parts:[
      pt('oct','dark',[0.86,0.86,0.86],[0,0.48,0], null, function(P,o){
          var k=o.q.bd; P.sx*=k; P.sy*=k; P.sz*=k; P.rx += o.t*2.2*o.mv; }),
      pt('oct','armor',[0.52,0.52,0.52],[0.34,0.66,0.18], null, function(P,o){
          P.rx += o.t*2.2*o.mv; P.ry += o.t*1.1; }),
      pt('oct','armor',[0.40,0.40,0.40],[-0.30,0.34,-0.22], null, function(P,o){
          P.rx += o.t*2.2*o.mv; }),
      pt('oct','void',[0.46,0.46,0.46],[-0.24,0.62,0.30]),
      pt('tor','glow',[0.68,0.68,0.40],[-0.24,0.62,0.30],[0.6,0.4,0], function(P,o){
          P.rz += o.t*1.4; var k = 1 + 1.4*o.tel + 1.8*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cyl','trim',[0.18,1.02,0.18],[0,0.48,0],[0,0,HP-0.2])
    ],
    ex:[ pt('oct','armorE',[0.34,0.34,0.34],[0.16,0.96,-0.16]),
         pt('oct','glowE',[0.18,0.18,0.18],[0.46,0.40,-0.26]) ],
    pose:function(o){ o.ry = 0.05*Math.abs(Math.sin(o.ph*Math.PI * 2))*o.mv;
      o.rp = o.tel*0.14 - o.atk*0.18; o.rr = 0.08; o.rz = -o.tel*0.20 + o.atk*0.88; }
  },
  {
    id:'iris', fam:'orb', deep:1, code:'IRIS', zh:'虹', role:'深層・凝視', tint:'vio',
    sil:'大球＋瞳孔是洞', h:1.24, w:1.16, wt:0.9,
    spd:1.3, turn:2.8, gait:1.5, rng:6.2, tTel:0.95, tAtk:0.30, tRec:1.10,
    q0:{bd:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'細瞳', q:{bd:0.86}, sp:1.34, sc:0.90},
          {n:'巨瞳', q:{bd:1.26}, sp:0.72, sc:1.16}],
    parts:[
      pt('oct','armor',[1.04,1.04,1.04],[0,0.66,0], null, function(P,o){
          var k=o.q.bd; P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('tor','glow',[1.10,1.10,0.42],[0.04,0.68,0.22], null, function(P,o){
          var k=o.q.bd*(1 + 0.30*o.tel); P.sx*=k; P.sy*=k; P.rz += o.t*0.7; }),
      pt('oct','void',[0.52,0.52,0.52],[0.04,0.68,0.34], null, function(P,o){
          var k = o.q.bd*(1 + 1.1*o.tel + 1.4*o.atk*(1-o.atk)); P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('box','armor',[0.20,0.44,0.44],[-0.42,0.94,-0.16],[0.3,0.4,0]),
      pt('cone','trim',[0.14,0.62,0.14],[ 0.30,0.31,-0.10],[Math.PI,0,0], legSwing( 1,0.31,0.26)),
      pt('cone','trim',[0.13,0.54,0.13],[-0.26,0.27, 0.08],[Math.PI,0,0], legSwing(-1,0.27,0.30))
    ],
    ex:[ pt('tor','glowE',[1.40,1.40,0.26],[0.04,0.68,0.10],[0.3,0,0]),
         pt('oct','armorE',[0.26,0.26,0.26],[0.44,1.02,-0.20]) ],
    pose:function(o){ o.ry = 0.04*Math.sin(o.ph*2*Math.PI * 2)*o.mv + 0.03*Math.sin(o.t*1.7);
      o.rp = 0.05 + 0.04*o.mv - o.tel*0.10; o.rr = -0.07; }
  }
];
